<div class="ar-stats">
    <div class="ar-stat ar-stat--total">
        <span class="ar-stat-label">Total CXC</span>
        <span class="ar-stat-value">{{ formatCurrency(arTotals.total) }}</span>
    </div>
    <div class="ar-stat ar-stat--current">
        <span class="ar-stat-label">Corriente</span>
        <span class="ar-stat-value">{{ formatCurrency(arTotals.current) }}</span>
    </div>
    <div class="ar-stat ar-stat--overdue">
        <span class="ar-stat-label">1 a 30 días</span>
        <span class="ar-stat-value">{{ formatCurrency(arTotals.d1_30) }}</span>
    </div>
    <div class="ar-stat ar-stat--overdue">
        <span class="ar-stat-label">31 a 60 días</span>
        <span class="ar-stat-value">{{ formatCurrency(arTotals.d31_60) }}</span>
    </div>
    <div class="ar-stat ar-stat--overdue">
        <span class="ar-stat-label">61 a 90 días</span>
        <span class="ar-stat-value">{{ formatCurrency(arTotals.d61_90) }}</span>
    </div>
    <div class="ar-stat ar-stat--overdue">
        <span class="ar-stat-label">91 a 120 días</span>
        <span class="ar-stat-value">{{ formatCurrency(arTotals.d91_120) }}</span>
    </div>
    <div class="ar-stat ar-stat--overdue">
        <span class="ar-stat-label">+ 120 días</span>
        <span class="ar-stat-value">{{ formatCurrency(arTotals.d120_plus) }}</span>
    </div>
</div>

<div class="ag-theme-alpine ar-grid" style="height: 560px; width: 100%;">
    <ag-grid-angular
        style="width: 100%; height: 100%;"
        class="ag-theme-alpine"
        [rowData]="arRowData"
        [columnDefs]="arColumnDefs"
        [defaultColDef]="defaultColDef"
        [headerHeight]="58">
    </ag-grid-angular>
</div>
